module.exports = __webpack_public_path__ + "img/9788925534909.2adbf5ce.jpg";